import { type FormInstance, message, Radio } from 'antd'
import { ModalRecommendation } from 'components'
import RadioRecommendation from 'components/RadioRecommendation'
import { useFamily } from 'context/hooks/useFamily'

import useQuery from 'context/hooks/useQuery'
import { useEffect, useMemo, useState } from 'react'
import {
  editRecommendation,
  getListRecommendation,
  postRecommendation,
  sendRecommendation,
} from 'services/recommedation'
import { type FamilyMemberType } from 'types/services/Family'
import {
  type Recommendation,
  type RecommendationGetList,
} from 'types/services/Recommedation'

import { isEmptyObject } from 'utils/utils'

import { getInfosMember, getMemberFamilyHead } from 'utils/familyUtils'

import './styles.scss'
import { useNavigate } from 'react-router-dom'
import GenericCardWithTitle from 'components/GenericCardWithTitle'

import Button from 'components/UI/Buttom'
import Arrow from 'components/Icons/Arrow'
import Back from 'components/Icons/Back'
import Add from 'components/Icons/Add'
import Edit from 'components/Icons/Edit'
import { Loading } from 'components/UI'
import RecommendationInfoCard from 'components/RecommendationInfoCard'
import ModalSendRecommendation from 'components/ModalSendRecommendation'
import {
  EducationIcon,
  HealthIcon,
  HousingIcon,
  IncomeIcon,
  NutritionIcon,
  PregnancyIcon,
} from 'components/Icons/IconsSections'
import { useAccessibility } from 'context/hooks/useAccessibility'

function RecommendationScreen() {
  const [modalIsOpen, setModalIsOpen] = useState(false)
  const [modalEditIsOpen, setModalEditIsOpen] = useState(false)

  const [isReload, setIsReload] = useState(true)

  const [listRecommendations, setListRecommendations] = useState<
    Recommendation[]
  >([] as Recommendation[])
  const [currentRecommendation, setCurrentRecommendation] =
    useState<Recommendation>({} as Recommendation)
  const [currentValueSelected, setCurrentValueSelected] = useState(0)
  const [isLoadingRecommendations, setIsLoadingRecommendations] =
    useState(false)

  const [modalSendRecommendationIsOpen, setModalSendRecommendationIsOpen] =
    useState(false)

  const [isPostingRecommedations, setIsPostingRecommedations] = useState(false)
  const [isSendingRecommedations, setIsSendingRecommedations] = useState(false)

  const [lastRecommendationSend, setLastRecommendationSend] =
    useState<Recommendation>({} as Recommendation)

  const [isRecommendationSend, setIsRecommendationSend] = useState(false)

  const { families } = useFamily()

  const navigate = useNavigate()

  const { contrastIsSelected } = useAccessibility()

  const {
    section,
    cpf,
    nis,
    familyCode,
    familyMemberName,
    fieldName,
    currenteBase,
    infosRecommedation,
    basesNames,
    area,
  } = useQuery()

  const { question, answer, isAlert, justification } =
    JSON.parse(infosRecommedation)

  const memberInfo: FamilyMemberType = getInfosMember(
    familyMemberName,
    currenteBase,
    families
  )

  const memberHeadInfo: FamilyMemberType = getMemberFamilyHead(
    currenteBase,
    families
  )

  const memberAndFamilyHeadInfo: FamilyMemberType[] = [
    memberInfo,
    memberHeadInfo,
  ]

  function handlePostRecommendation(form: FormInstance) {
    const dataPost: Recommendation = {
      ...form.getFieldsValue(),
      ...(cpf.length > 0 && { cpf }),
      ...(nis.length > 0 && { nis }),
      ...(familyCode.length > 0 && { familyCode }),
      ...(familyMemberName.length > 0 && {
        recommendationMemberName: familyMemberName,
      }),
      ...(fieldName.length > 0 && { recommendationField: fieldName }),
      ...(currenteBase.length > 0 && { recommendationBase: currenteBase }),
    }

    setIsPostingRecommedations(true)

    postRecommendation(dataPost)
      .then(() => {
        message.success('Recomendação salva com sucesso!')
        setModalIsOpen(false)
        setIsReload(true)
      })
      .catch((err) => {
        message.error('Ocorreu um erro ao salvar a recomendação!', err)
      })
      .finally(() => {
        setIsPostingRecommedations(false)
      })
  }

  function handleEditRecommendation(form: FormInstance) {
    const dataPost: Recommendation = {
      ...form.getFieldsValue(),
      ...(cpf.length > 0 && { cpf }),
      ...(nis.length > 0 && { nis }),
      ...(familyCode.length > 0 && { familyCode }),
      ...(familyMemberName.length > 0 && {
        recommendationMemberName: familyMemberName,
      }),
      ...(fieldName.length > 0 && { recommendationField: fieldName }),
      ...(currenteBase.length > 0 && { recommendationBase: currenteBase }),
    }

    setIsPostingRecommedations(true)

    editRecommendation(currentRecommendation.id ?? 0, dataPost)
      .then(() => {
        message.success('Recomendação editada com sucesso!')
        setModalEditIsOpen(false)
        setIsReload(true)
      })
      .catch((err) => {
        message.error('Ocorreu um erro ao editar a recomendação!', err)
      })
      .finally(() => {
        setIsPostingRecommedations(false)
      })
  }

  function handleSendRecommendation(id: number) {
    setIsSendingRecommedations(true)

    const infosRecommedation = {
      question,
      answer,
      alert: isAlert,
      justification,
      url: window.location.href,
      area,
    }

    sendRecommendation(id, infosRecommedation)
      .then(() => {
        message.success('Recomendação encaminhada com sucesso!')
        setModalSendRecommendationIsOpen(false)
        setIsReload(true)
      })
      .catch((err) => {
        message.error('Ocorreu um erro ao encaminhar essa recomendação!', err)
      })
      .finally(() => {
        setIsSendingRecommedations(false)
      })
  }

  useEffect(() => {
    if (isReload) {
      setIsLoadingRecommendations(true)
      const data: RecommendationGetList = {
        ...(cpf.length > 0 && { cpf }),
        ...(nis.length > 0 && { nis }),
        ...(familyCode.length > 0 && { codFamiliar: familyCode }),
        ...(fieldName.length > 0 && { fieldName }),
        ...(familyMemberName.length > 0 && { familyMemberName }),
      }
      getListRecommendation(data)
        .then(({ data }) => {
          if (data.length > 0) {
            // ordena as recomendações pela ordem de criação
            data.sort(
              (a: Recommendation, b: Recommendation) =>
                new Date(b.createdAt).valueOf() -
                new Date(a.createdAt).valueOf()
            )
            setListRecommendations(data)
            setCurrentValueSelected(data[0].id)
            setCurrentRecommendation({ ...data[0] })

            let lastRecommendation = lastRecommendationSend

            data.forEach((recommendation: Recommendation) => {
              const sentAt = new Date(lastRecommendation.sentAt ?? 0).getTime()
              const sentAtCurrent = new Date(
                recommendation.sentAt ?? 0
              ).getTime()

              if (sentAtCurrent >= sentAt && recommendation.isSent === true) {
                lastRecommendation = recommendation
              }

              if (recommendation.isSent === true) setIsRecommendationSend(true)
            })

            setLastRecommendationSend(lastRecommendation)
          }
        })
        .catch((err) => {
          message.error('Ocorreu um erro ao buscar os alertas!', err)
        })
        .finally(() => {
          setIsLoadingRecommendations(false)
        })

      setIsReload(false)
    }
  }, [isReload])

  function handleChangeRadio(value: number) {
    setCurrentValueSelected(value)
    const newCurrentRecommendation = listRecommendations.filter(
      (recommendation) => recommendation.id === value
    )[0]
    setCurrentRecommendation(newCurrentRecommendation)
  }

  const sectionsObj = useMemo(
    () => ({
      renda: {
        icon: <IncomeIcon fill={'#2d4040'} />,
        label: 'Renda',
      },
      educacao: {
        icon: <EducationIcon fill={'#2d4040'} />,
        label: 'Educação',
      },
      habitacao: {
        icon: <HousingIcon fill={'#2d4040'} />,
        label: 'Habitação',
      },
      saude: {
        icon: <HealthIcon fill={'#2d4040'} />,
        label: 'Saúde',
      },
      gravidez: {
        icon: <PregnancyIcon fill={'#2d4040'} />,
        label: 'Gravidez',
      },
      nutricao: {
        icon: <NutritionIcon fill={'#2d4040'} />,
        label: 'Nutrição',
      },
    }),
    []
  )

  const recommendationsList = useMemo(() => {
    if (listRecommendations.length > 0) {
      return (
        <Radio.Group
          onChange={(event) => {
            handleChangeRadio(event.target.value)
          }}
          value={currentValueSelected}
          className="radio-recommendations"
        >
          {listRecommendations.map((recommendation: Recommendation) => {
            return (
              <RadioRecommendation
                key={recommendation.id}
                value={recommendation.id ?? 0}
                currentValue={currentValueSelected}
                setCurrentValue={setCurrentValueSelected}
                setCurrentRecommendation={setCurrentRecommendation}
                infos={recommendation}
              />
            )
          })}
        </Radio.Group>
      )
    } else if (isLoadingRecommendations) {
      return <Loading styles={{ margin: '10rem auto' }} size={'small'} />
    }
    return (
      <div className="containerRecommendationScreen-recommendationsList__noRegistry">
        <h1>Ainda não há recomendações para esta condição</h1>
      </div>
    )
  }, [listRecommendations, isLoadingRecommendations])

  return (
    <section
      className={`containerRecommendationScreen ${
        contrastIsSelected ? 'contrastMode' : ''
      }`}
    >
      <ModalRecommendation
        question={question}
        answer={answer}
        justification={justification}
        modalIsOpen={modalIsOpen}
        closeModal={() => {
          setModalIsOpen(false)
        }}
        isAlert={isAlert}
        action={handlePostRecommendation}
        loading={isPostingRecommedations}
        initialValues={{} as Recommendation}
      />

      <ModalRecommendation
        question={question}
        answer={answer}
        justification={justification}
        modalIsOpen={modalEditIsOpen}
        closeModal={() => {
          setModalEditIsOpen(false)
        }}
        isAlert={isAlert}
        action={handleEditRecommendation}
        loading={isPostingRecommedations}
        initialValues={currentRecommendation}
        editMode
      />

      <ModalSendRecommendation
        question={question}
        answer={answer}
        justification={justification}
        modalIsOpen={modalSendRecommendationIsOpen}
        closeModal={() => {
          setModalSendRecommendationIsOpen(false)
        }}
        isAlert={isAlert}
        action={handleSendRecommendation}
        infosRecommedation={currentRecommendation}
        isRecommendationSend={isRecommendationSend}
        loading={isSendingRecommedations}
      />

      <GenericCardWithTitle
        title={'Recomendações'}
        subtitle={
          'Selecione, crie ou edite recomendações para essa condição familiar'
        }
      >
        <div className="containerRecommendationScreen-actionButtons">
          <Button
            title="Voltar"
            icon={<Back />}
            type="secondary"
            width="24rem"
            onClick={() => {
              navigate(-1)
            }}
          />

          <Button
            title="Criar"
            icon={<Add />}
            type="secondary"
            width="24rem"
            onClick={() => {
              setModalIsOpen(true)
            }}
          />

          <Button
            title="Editar"
            icon={<Edit />}
            disabled={
              !!(
                isEmptyObject(currentRecommendation) ||
                currentRecommendation.isSent === true
              )
            }
            type="secondary"
            width="24rem"
            onClick={() => {
              setModalEditIsOpen(true)
            }}
          />
        </div>
        <div className="containerRecommendationScreen-recommendationsList">
          {recommendationsList}
        </div>
      </GenericCardWithTitle>
      <GenericCardWithTitle
        title={sectionsObj[section].label}
        icon={sectionsObj[section].icon}
        subtitle={basesNames[currenteBase]}
      >
        <Button
          title="Encaminhar"
          icon={<Arrow />}
          width="100%"
          type="primary"
          onClick={() => {
            setModalSendRecommendationIsOpen(true)
          }}
          disabled={
            !!(
              isEmptyObject(currentRecommendation) ||
              currentRecommendation.isSent === true
            )
          }
        />

        <RecommendationInfoCard
          answer={answer}
          question={question}
          isAlert={isAlert}
          justificationText={justification}
          memberAndFamilyHeadInfo={memberAndFamilyHeadInfo}
          key={question}
          infosRecommedation={lastRecommendationSend}
        />
      </GenericCardWithTitle>
    </section>
  )
}

export default RecommendationScreen
